import api_company from "../../api/api_company.js"

const state = {
  company_name: null,
  company_string: null,
};


const getters = {
  getCompanyName: state => state.company_name,
  getCompanyString: state => state.company_string
};


const actions = {
  async performRecordUserInteraction({commit}, payload) {
    const response = await api_company.recordUserInteraction(payload)
    if (!response)  {
      commit("setFormError", null);
    } else {
      commit("setFormError", null);
    }
  },
  async getCompanyInfo({ commit }) {
    const response = await api_company.companyInfo();
    if (!response)  {
      console.log("No company details present")
    }
    else {
      commit('setCompanyName', response.company_name);
      commit('setCompanyString', response.company_string);
    }
  },
};

const mutations = {
  setCompanyName: (state, company_name) => {
    state.company_name = company_name
  },
  setCompanyString: (state, company_string) => {
    state.company_string = company_string
  },
};


export default {
  state,
  getters,
  actions,
  mutations
}